// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__9R2an","header":"MessagesList_header__2K7I7","chat":"MessagesList_chat__1w2CV"};